import { Link } from "react-router-dom";
import { LANDING_PLAN_CLICK_ALL, track } from "./landingTrack";

const SKELETON_KEYS = [0, 1, 2] as const;

/**
 * Three skeleton cards while the catalog request has not finished.
 *
 * No price and no plan text. The parent section sets aria-busy.
 */
export function LandingPlansSkeleton() {
  return (
    <ul className="landing-plans__cards" aria-hidden="true">
      {SKELETON_KEYS.map((key) => (
        <li key={key} className="landing-plans__item">
          <div className="landing-plans__card landing-plans__card--skeleton">
            <span className="landing-plans__bone landing-plans__bone--title" />
            <span className="landing-plans__bone landing-plans__bone--line" />
            <span className="landing-plans__bone landing-plans__bone--price" />
            <span className="landing-plans__bone landing-plans__bone--button" />
          </div>
        </li>
      ))}
    </ul>
  );
}

/**
 * No eligible plan. The catalog control is "Ver página de planos".
 */
export function LandingPlansEmpty() {
  return (
    <div className="landing-plans__status">
      <p className="landing-plans__status-title">Os planos estão sendo atualizados</p>
      <p className="landing-plans__status-body">
        Confira todos os planos na página de planos.
      </p>
      <Link
        className="landing-plans__catalog"
        to="/planos"
        onClick={() => {
          track("landing_plan_clicked", { product_id: LANDING_PLAN_CLICK_ALL });
        }}
      >
        Ver página de planos
      </Link>
    </div>
  );
}

/**
 * Catalog failure or the 8 second timeout.
 *
 * `onRetry` is the parent's retry. The parent swaps this view for the
 * skeleton when the status returns to loading and requests the catalog again.
 */
export function LandingPlansError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="landing-plans__status" role="alert">
      <p className="landing-plans__status-title">
        Não foi possível carregar os planos agora
      </p>
      <p className="landing-plans__status-body">
        Você pode ver todos os planos e preços na página de planos.
      </p>
      <div className="landing-plans__status-actions">
        <Link
          className="landing-plans__catalog"
          to="/planos"
          onClick={() => {
            track("landing_plan_clicked", { product_id: LANDING_PLAN_CLICK_ALL });
          }}
        >
          Ver planos
        </Link>
        <button type="button" className="landing-plans__retry" onClick={onRetry}>
          Tentar de novo
        </button>
      </div>
    </div>
  );
}
